var DgPorTableMixins = {
	methods: {
		/**
		 * 将表格请求数据之后处理的逻辑剥离出来，然后根据父组件传来的successBack属性来决定是否执行对应的成功回调方法
		 * @param {Object} response
		 */
		afterGetData(response) {
			if (response.success == true || response.success == false) {
				if (response.success == false) {
					this.tableData = null;
					this.resultSize = 0;
					this.$emit('getTotal', 0);
				} else {
					let tableData = eval("response." + this.prop.dataProp);
					this.tableData = tableData
					this.resultSize = response.data.total;
					console.info("resultSize-->" + this.resultSize);
					this.$emit('getTotal', response.data.total);
				}
				if (this.prop.pageableProp) {
					if (response.success == false) {
						this.pagination.total = 0;
					} else {
						this.pagination.total = eval("response." + this.prop.pageableProp);
					}
				}
				if (this.prop.successBack) {
					this.prop.successBack.apply(this, [].concat(response));
				}

				this.loading = false;
			}
			//合并添加
			if (response.code == 1 || response.code == 0) {

				if (this.prop.back) {
					let code = eval("response." + this.prop.codeProp);
					if (code == 0) {
						this.tableSpinShow = false;
						this.loading = false;
						let message = eval("response." + this.prop.messageProp);
						this.$Message.info(message);
						return;
					}
				}
				if (response.code == 1) {
					let otherData = eval("response." + this.prop.otherProp);
					let tableData = eval("response." + this.prop.dataProp);
					this.tableData = tableData
					// this.otherData = otherData;
					if (this.prop.pageableProp) {
						this.pagination.total = eval("response." + this.prop.pageableProp);
					}
					if (this.prop.successBack) {
						this.prop.successBack.apply(this, [].concat(response));
					}
					if (null != otherData) {
						this.$emit('getCommandAll', otherData);
					}
					if (null != tableData) {
						this.$emit('getTable', tableData);
					}
					this.tableSpinShow = false;
					this.loading = false;

				} else {
					this.tableSpinShow = false;
					this.loading = false;
					this.$Message.error(response.message);
				}

			}
		},
		getData() {
			if (this.prop.dataFun) {
				this.prop.dataFun.apply(this, [].concat(this.prop.dataFunArgs))
				return
			}
			if (this.prop.postMethod) {
				this.tableSpinShow = this.prop.spin;
				this.loading = true;
				this.constructPostData(this.prop.postData);
				if (this.$switch == false) {

					if (this.prop.noPostParams === true) {
						this.getApiData('post', this.prop.dataSrc, this.prop.postData, response => {
							this.afterGetData(response)
						});
					} else {
						this.getApiData('post', this.prop.dataSrc, {
							params: this.prop.postData
						}, response => {
							this.afterGetData(response)
						});
					}
				} else {
					if (this.prop.noPostParams === true) {
						this.$TokenHandler.postFun(this.prop.dataSrc, this.prop.postData, (response) => {
							this.afterGetData(response);
						});
					} else {
						// this.$TokenHandler.post(this.prop.dataSrc + "?randomCount=" + new Date().getTime(), this.prop.postData, (response) => {
						this.$TokenHandler.post(this.prop.dataSrc, this.prop.postData, (response) => {
							this.afterGetData(response);
						});
					}
				}

			} else {
				this.constructPostData(this.prop.postData);
				if (this.$switch == false) {
					this.getApiData('get', this.prop.dataSrc, {
						params: this.prop.postData
					}, response => {
						this.afterGetData(response);
					});
				} else {
					this.$TokenHandler.get(this.prop.dataSrc, this.prop.postData, (response) => {
						this.afterGetData(response);
					});
				}
			}
		},
		constructPostData(postData) {
			if (this.prop.postMethod) {
				let pageData = this.prop.offsetLimit ? {
					offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
					limit: this.pagination.pageSize,
					order: this.pagination.order,
					sort: this.pagination.sort
				} : {
					page: this.pagination.currentPage - 1,
					rows: this.pagination.pageSize,
					order: this.pagination.order,
					sort: this.pagination.sort
				}
				Object.assign(postData, pageData);
				// console.log("请求数据" + Object.assign(postData, pageData))
			} else {

				let pageData = {
					O: (this.pagination.currentPage - 1) * this.pagination.pageSize,
					L: this.pagination.pageSize,
					order: this.pagination.order,
					sort: this.pagination.sort
				}
				Object.assign(postData, pageData);
				console.log("请求数据" + Object.assign(postData, pageData))
			}
		},
		handleCurrentRowChange(row) {
			this.currentRow = row
		},

		/**
		 * 分页大小变更时事件
		 * @param pageSize
		 */
		handleSizeChange(pageSize) {
			let tempPage = _.cloneDeep(this.pagination.currentPage);
			this.pagination.pageSize = pageSize;
			if (tempPage != 1) {
				this.pagination.currentPage = 1
			} else {
				this.getData();
			}
		},
		/**
		 * 页数变更时事件
		 * @param pageSize
		 */
		handleCurrentPageChange(currPage) {
			this.pagination.currentPage = currPage;
		},

		handleSortChange(col) {
			if (col.order == "normal") {
				this.pagination.sort = null;
				this.pagination.order = null;
			} else {
				this.pagination.sort = col.key;
				this.pagination.order = col.order;
			}
			this.getData()

		},
		/**
		 * 刷新数据
		 */
		refreshData() {
			this.getData()
		},
		/**
		 * 获取表头上的操作按钮
		 * @returns {*}
		 */
		getActions() {
			if (this.prop.showActions == false) {
				return null;
			}
			if (this.prop.actions) {
				this.prop.actions.def.forEach((item) => {
					item.handler = () => {
						item.action.apply(this, [])
					}
				})
				if (this.prop.actions.replace) {
					Object.assign(this.actions, this.prop.actions)
				} else {
					this.actions.def = this.actions.def.concat(this.prop.actions.def)
				}
			}
			return this.actions
		},
		handleRowClick(row, index) {
			this.$emit('rowClick', row)
			//如果点击的是selection则return,否则会出触发2次handleSelect
			if (row.type == 'selection') {
				var index = this.tableData.indexOf(row)
				return false;
			}
			//默认点击不选中，如果传参数rowClickSelect为true时单击row切换选中状态
			if (this.prop.rowClickSelect) {
				this.$refs.elTable.toggleRowSelection(row);
			}
			if (this.prop.rowClick) {
				this.prop.rowClick.apply(this, [row])
			}
		},
		getSelectRow(selection) {
			this.$emit('getselsectData', selection);
		},
		getAllRow(selection) {
			this.$emit('getselsectData', selection);
		},
		unSelectAll(selection) {
			// debugger;
			this.$emit('unSelectAll', selection);
		},
		handleSelectAll(status) {
			// debugger;
			this.$refs.elTable.selectAll(status);
		},
		setTableHeight(value) {
			// debugger;
			this.tableHeight = value;
		},
		setTableSize(value) {
			this.tableSize = value;
		},
		setPageShow(value) {
			this.pageShow = value;
		},
		selectTableData(value) {
			this.tableData = value;
		},
		clearCurrentRow() {
			this.$refs.elTable.clearCurrentRow();
		}


	},
	computed: {
		paginationDef() {
			if (this.prop.pageInfo) {
				Object.assign(this.pagination, this.prop.pageInfo)
			}
			return this.pagination
		},
		currentPage() {
			return this.pagination.currentPage
		},
		spinShow() {
			return this.$store.state.tableSpinShow
		},
		selectedLength() {
			return this.multipleSelection.length;
		}
	},
	created() {
		/**
		 * 新增默认排序功能，根据列定义的sortType进行排序
		 */
		let column = this.prop.columns.filter((item) => {
			return item.sortType
		})
		if (column.length > 0) {
			let col = column[column.length - 1];
			this.pagination.order = col.key + "," + col.sortType.toUpperCase();
		}
		this.getData()
		clearInterval(this.timer)
		/**
		 * 新增定时器刷新页面
		 */
		if (this.prop.timeout) {
			this.timer = setInterval(() => {
				if (this.multipleSelection.length == 0) {
					this.getData();
				}
			}, this.prop.timeout)
		}
		this.getActions()
	},
	watch: {
		currentPage(val) {
			/**
			 * 防止页码切换过快，导致异步数据因返回速度差异导致渲染出错
			 */
			clearTimeout(this.pageTimeout)
			this.pageTimeout = setTimeout(() => {
				this.getData();
			}, 150);
		}
	}
}

export default DgPorTableMixins;



// WEBPACK FOOTER //
// ./src/components/dynamicTable/DgPorTableMixins.js